var map = {
	"./calculator/index.js": 49433,
	"./customer2/index.js": 22720,
	"./customers/index.js": 63569,
	"./index.js": 63093,
	"./pricing/index.js": 16686,
	"./products/index.js": 56157,
	"./solution/index.js": 44954
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 33996;